module.exports = __webpack_public_path__ + "img/icon-pay-cancel-off-v2.16786e3.png";